import { removeCookie } from '../../utils/cookie';
import { post } from '../../common/ApiClient';
import {
  LoginResponse,
  CheckEmailResponse,
  LoginRequest,
  SendEmailVerificationResponse,
  VerifyEmailResponse,
  RegisterRequest,
  RegisterResponse,
} from '../types/Auth';

export const login = async (userData: LoginRequest): Promise<LoginResponse> => {
  let formData = new FormData();
  formData.append('email', userData.email);
  formData.append('password', userData.password);

  const { data } = await post<LoginResponse>('/users/login', false, formData);

  return data;
};

export const validateEmail = async (email: string): Promise<CheckEmailResponse> => {
  let formData = new FormData();
  formData.append('email', email);

  const { data } = await post<CheckEmailResponse>('/users/check-email', false, formData);

  return data;
};

export const register = async (registerRequest: RegisterRequest): Promise<RegisterResponse> => {
  let formData = new FormData();
  formData.append('email', registerRequest.email);
  formData.append('password', registerRequest.password);
  formData.append('referer', registerRequest.referer);

  const { data } = await post<RegisterResponse>('/users/create', false, formData);

  return data;
};

export const resetPassword = async (password: string, token: string): Promise<LoginResponse> => {
  let formData = new FormData();
  formData.append('token', token);
  formData.append('new_password', password);

  const { data } = await post<LoginResponse>('/users/password-reset-confirm', false, formData);

  return data;
};

export const verifyEmail = async (email: string, digits: string): Promise<VerifyEmailResponse> => {
  let formData = new FormData();
  formData.append('email', email);
  formData.append('code', digits);

  const { data } = await post<VerifyEmailResponse>('/users/set-email-validated', false, formData);

  return data;
};

export const sendEmailVerification = async (email: string): Promise<SendEmailVerificationResponse> => {
  let formData = new FormData();
  formData.append('email', email);
  formData.append('code', 'email-verification');

  const { data } = await post<SendEmailVerificationResponse>('/users/send-email', false, formData);

  return data;
};

export const requestPasswordReset = async (email: string, referer?: string): Promise<CheckEmailResponse> => {
  let formData = new FormData();
  formData.append('email', email);

  if (referer) {
    formData.append('resetUrl', referer ?? '');
  }

  const { data } = await post<CheckEmailResponse>('/users/password-reset-request', false, formData);

  return data;
};

export const logout = () => {
  if (window?.location && window?.location?.href) {
    removeCookie('n_token');

    const encodedCurrentLocation = encodeURIComponent(window.location.href);

    const logoutUrl = `${
      window.crmUrl || process.env.REACT_APP_CRM_BASE_URI
    }/users/sign/out?url=${encodedCurrentLocation}`;

    window.sessionStorage.clear();

    window.location.href = logoutUrl;
  }
};
